var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-widerrufsbelehrung","title":"Widerrufsbelehrung","size":"lg","ok-only":true,"ok-title":'schließen'}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.widerrufsbelehrung_html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }